import {css} from 'lit';
export const styles = css`:host {
  --body-bg: var(--gray-200);

  display: block;
  background-color: var(--body-bg);
}

:host([layout='absolute']) {
  position: relative;
}

:host([layout='absolute']) slot::slotted(*) {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  object-fit: cover;
}

:host([layout='static']) slot::slotted(*) {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  max-height: calc(50vb * 1.4);
}
`;
export default styles;
